/**
 * 页面逻辑说明浮窗（半透明，可关闭）
 * 每个页面右侧显示当前页的业务逻辑说明，点 × 可关闭（本会话内不再出现）。
 */

import { useState, type ReactNode } from 'react'

const SESSION_KEY = 'ecom_help_dismissed'

/** 读取本会话已关闭的页面 key */
function getDismissed(): Set<string> {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY)
    return new Set(raw ? JSON.parse(raw) : [])
  } catch {
    return new Set()
  }
}

function setDismissed(keys: Set<string>) {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify([...keys]))
  } catch {
    // ignore
  }
}

export function HelpBubble({ pageKey, title, children }: { pageKey: string; title: string; children: ReactNode }) {
  const [dismissed, setDismissedState] = useState(() => getDismissed().has(pageKey))

  if (dismissed) return null

  function close() {
    const keys = getDismissed()
    keys.add(pageKey)
    setDismissed(keys)
    setDismissedState(true)
  }

  return (
    <div
      style={{
        position: 'fixed',
        right: 16,
        bottom: 16,
        maxWidth: 300,
        background: 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(8px)',
        border: '1px solid #d1d5db',
        borderRadius: 10,
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        padding: 14,
        zIndex: 100,
        fontSize: 12.5,
        lineHeight: 1.7,
        color: '#374151',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
        <strong style={{ fontSize: 13, color: '#1f2937' }}>💡 {title}</strong>
        <button
          onClick={close}
          style={{
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            fontSize: 16,
            color: '#9ca3af',
            lineHeight: 1,
            padding: '0 0 0 8px',
          }}
          aria-label="关闭说明"
        >
          ×
        </button>
      </div>
      <div>{children}</div>
    </div>
  )
}
